'use client';
import { COUNTRY_CODE, WHATSAPP_NUMBER } from '@/constants';
import { FC } from 'react';
import { usePathname } from 'next/navigation';
import { useCleverTap } from '@/context/clevertapContext';
import { useUser } from '@/context/userContext';
import { WhatsappIcon } from '@/icons';
import Svg from '../Svg';

const WhatsappMenu: FC = () => {
  const pathname = usePathname();
  const { pushEvent } = useCleverTap();
  const { userDetails } = useUser();
  const contactNumber = `${COUNTRY_CODE}${WHATSAPP_NUMBER}`;
  const dataToTrack = {
    Name: userDetails?.firstname
      ? `${userDetails?.firstname} ${userDetails?.lastname}`
      : 'Guest User',
    'Mobile Number': userDetails?.mobilenumber ?? 'NA',
    Email: userDetails?.email ?? 'NA',
    From: 'Hamburger Menu',
    Path: pathname === '/' ? 'Home' : pathname,
    'Logged In': userDetails?.id ? 'Yes' : 'No',
  };

  function handleWhatsappClick() {
    pushEvent({
      event: 'Whatsapp Interaction',
      data: dataToTrack,
    });
    window.open(
      `https://api.whatsapp.com/send?phone=91${WHATSAPP_NUMBER}&text=Hi&utm_source=Whatsapp&utm_medium=Clevetap&utm_campaign=Whatsapp_icon_web&utm_term=030624`,
      '_blank'
    );
  }

  return (
    <button
      className='group flex basis-1/4 items-center justify-start text-start max-[375px]:w-full'
      onClick={handleWhatsappClick}>
      <div className='flex cursor-pointer items-start gap-x-3 p-5 pb-28'>
        <Svg
          fill='none'
          className='fill-black stroke-black stroke-[0.7] opacity-60'
          viewBox='-1 1 21 17'>
          <WhatsappIcon />
        </Svg>
        <span>WhatsApp us on: {contactNumber}</span>
      </div>
    </button>
  );
};

export default WhatsappMenu;
